import { call, put, takeLatest } from "redux-saga/effects";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { v4 as uuidv4 } from "uuid";

import { mucThuKhacTinChiSinhVienApi } from "../../../api/chung-tu/mucThuKhacTinChiSinhVienApi";
import { IMucThuKhacSinhVienSaveHocPhiTinChiRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSaveHocPhiTinChiRequest";
import { IDanhSachLopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectRequest";
import {
  eMucThuTinChiActionIds,
  IMucThuTinChiActionTypes,
} from "../../action-types/muc-thu/IMucThuTinChiActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IMucThuKhacSinhVienSelectByLopsRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectByLopsRequest";
import { mucThuKhacSinhVienApi } from "../../../api/chung-tu/mucThuKhacSinhVienApi";
import { ISinhVienSelectByLopsRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";

export function* mucThuTinChiSaga(): any {
  yield takeLatest(eMucThuTinChiActionIds.LOAD_HOCSINH_START, loadWorker);
  yield takeLatest(eMucThuTinChiActionIds.CALCULATE_START, caculateWorker);
  yield takeLatest(eMucThuTinChiActionIds.SAVE_CALCULATE_START, saveWorker);
  yield takeLatest(
    eMucThuTinChiActionIds.LOAD_MUCTHUKHAC_START,
    loadMucThuWorker,
  );
}

function* loadWorker(action: IMucThuTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    sinhVienApi.SelectByLops,
    action.payload as ISinhVienSelectByLopsRequest,
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThuTinChi.LOAD_HOCSINH_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.LOAD_HOCSINH_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* caculateWorker(action: IMucThuTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacTinChiSinhVienApi.Caculate,
    action.payload as IDanhSachLopTinChiSelectRequest,
  );
  if (res.is_success) {
    yield put(rootActions.mucThu.mucThuTinChi.CALCULATE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.CALCULATE_ERRR(res.message ?? "Có lỗi"),
    );
  }
}

function* saveWorker(action: IMucThuTinChiActionTypes): any {
  var req = action.payload as IMucThuKhacSinhVienSaveHocPhiTinChiRequest;
  const res: IBaseRespone = yield call(
    mucThuKhacTinChiSinhVienApi.SaveCaculate,
    req,
  );
  if (res.is_success) {
    if (req.is_approve) {
      const process_id = uuidv4();
      yield put(
        rootActions.mucThu.mucThu.DUYET_MUCTHUKHAC_START({
          payload: res.data as number[],
          process_id,
        }),
      );
    }
    yield put(rootActions.mucThu.mucThuTinChi.SAVE_CALCULATE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.SAVE_CALCULATE_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}

function* loadMucThuWorker(action: IMucThuTinChiActionTypes): any {
  const res: IBaseRespone = yield call(
    mucThuKhacSinhVienApi.SelectVmByLops,
    action.payload as IMucThuKhacSinhVienSelectByLopsRequest,
  );
  if (res.is_success) {
    yield put(
      rootActions.mucThu.mucThuTinChi.LOAD_MUCTHUKHAC_SUCCESS(res.data),
    );
  } else {
    yield put(
      rootActions.mucThu.mucThuTinChi.LOAD_MUCTHUKHAC_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}
